<template>
  <div>
    <div>
      <b-form-group :label="$t('message.Включен') + ':'" label-for="Enabled">
        <b-form-checkbox-group v-model="model.enabled" id="Enabled">
          <b-form-checkbox
            value="true"
            :disabled="!hasFullyManage"
          ></b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>
      <b-form-group :label="$t('message.Название') + ':'" label-for="Name">
        <b-form-input
          id="Name"
          type="text"
          v-model="model.name"
          :disabled="!hasFullyManage"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group
        :label="$t('message.Колокейшин_запасной_включен') + ':'"
        label-for="Enabled"
      >
        <b-form-checkbox-group v-model="model.spare_enabled" id="Enabled">
          <b-form-checkbox
            value="true"
            :disabled="!hasFullyManage && !hasSetSpareEnabled"
          ></b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>
      <b-form-group
        :label="$t('message.Колокейшн_запасной') + ':'"
        label-for="Colocation"
      >
        <v-select
          v-model="model.spare_colocation"
          :options="this.colocations"
          label="name"
          :disabled="!hasFullyManage"
        ></v-select>
      </b-form-group>
    </div>
  </div>
</template>
<script>
export default {
  name: "ColocationForm",
  props: ["model"],
  data() {
    return {
      colocations: []
    };
  },
  beforeUpdate() {},
  computed: {
    hasFullyManage: function() {
      return !!this.$storage
        .get("current_user")
        .permissions.filter(value => value == "colocations:fully_manage")
        .length;
    },
    hasSetSpareEnabled: function() {
      return !!this.$storage
        .get("current_user")
        .permissions.filter(value => value == "colocations:set_spare_enabled")
        .length;
    }
  },
  created: function() {
    let promise_spare_colocation = this.$noname.get("colocations");
    promise_spare_colocation
      .then(data => {
        this.colocations = data.data.items;
      })
      .catch(error => {
        Vue.notify({
          group: "notify",
          text:
            this.$i18n.t("message.Не_удалось_получить_колокейшинов") +
            ":<br>" +
            error,
          type: "error"
        });
      });
  },
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/modules/ColocationForm.vue